import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { cartAtom } from '@/store/atoms';
import { Article } from '@/types';

const useCheckItemCartQuantity = (article: Article) => {
  const { retailerId = '1' } = useParams();
  const cart = useAtomValue(cartAtom);
  const retailerCart = cart[retailerId];

  return useMemo(() => {
    if (!article) return 0;
    if (retailerCart?.length === 0) {
      return 0;
    } else {
      const deliveryWithItem = retailerCart?.find((delivery) =>
        delivery.items.some((item) => item.catalogueID === article.id),
      );

      if (deliveryWithItem) {
        const itemInCart = deliveryWithItem.items.find(
          (item) => item.catalogueID === article.id,
        );
        return itemInCart ? itemInCart.quantity : 0;
      } else {
        return 0;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retailerCart, article, cart]);
};

export default useCheckItemCartQuantity;
